import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function Brightness2Icon(props: IconProps) {
    return <Icon {...props} iconKey={"brightness_2"}/>
}
